import { addCyPrefixToIDs } from 'moet-test-utils/cypress/utils';

const cyPrefix = 'containers_sensitive_goods_container';

export const CY_SENSITIVE_GOODS_CONTAINER_IDS = {
  ...addCyPrefixToIDs(cyPrefix, { BTN_BACK: 'BTN_BACK', BTN_CONTINUE: 'BTN_CONTINUE' }),
  OPTION: option => `OPTION_${option}`,
  OPTION_NONE: 'OPTION_NONE',
};

export const linkEthicalInstructions =
  'https://docs.klarna.com/resources/legal-and-compliance/policies-and-term-of-service/prohibited-and-restricted-businesses/';

export const T_PREFIX = 'products-fe.containers.sensitive_goods';

export const DEFAULT_SENSITIVE_GOODS_VALUE = 'NONE';

export const SENSITIVE_GOODS = [
  'CBD_HEMP_TOBACCO_ECIGARETTES_VAPE',
  'WEAPONS_AMMUNITION',
  'PHARMACEUTICALS',
  'EVENTS_TICKETS_TOURISM_TRAVEL_VOUCHERS',
  'MARKETPLACE',
  'SERVICES_SUBSCRIPTIONS_MEMBERSHIPS_RENTALS_CONTENT',
  'NONE',
];

export const SENSITIVE_GOODS_TO_MARKETO = {
  CBD_HEMP_TOBACCO_ECIGARETTES_VAPE: 'CBD, hemp, tobacco, e-cigarettes, vape',
  EVENTS_TICKETS_TOURISM_TRAVEL_VOUCHERS: 'Events, tickets, tourism, travel, vouchers',
  WEAPONS_AMMUNITION: 'Weapons, ammunition (sports, outdoor, hunting)',
  MARKETPLACE: 'Marketplace',
  PHARMACEUTICALS: 'Pharmaceuticals prescription and non-prescription',
  SERVICES_SUBSCRIPTIONS_MEMBERSHIPS_RENTALS_CONTENT:
    'Services, subscriptions, memberships, rentals, content',
  NONE: 'None',
};
